export var text = {
    group: 'inline',
};
